import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/BreadcrumbFilters"

//i18n
import { withTranslation } from "react-i18next"

//redux
// import { branches } from "./../../../../common/data/companies"
import { useDispatch, useSelector } from "react-redux"
import { getBranches as onList } from "store/actions"
import TableContainerServerSide from "components/Common/TableContainerServerSide"

//Custom CSS
import "./custom.scss"
import moment from "moment"
import { Link } from "react-router-dom"
import { replaceAll } from "helpers/functions"
import TableContainer from "../../../../components/Common/TableContainer"
import { isEmpty } from "lodash"

const Branches = props => {
  //meta title
  document.title = props.t("Branches")

  const dispatch = useDispatch()
  const { error, branches, branchesTableOptions, loading } = useSelector(
    state => ({
      error: state.Companies?.error,
      branches: state.Companies?.branches || [],
      branchesTableOptions: state.Companies?.branchesTableOptions || null,
      loading: state.Companies?.loading || false,
    })
  )

  const breadcrumbItems = [
    { title: props.t("Companies"), link: "/v1/companies" },
    { title: props.t("Branches"), link: "/" },
  ]

  const [selectedItem, setSelectedItem] = useState("all")
  const [tableSetting, setTableSetting] = useState({
    orderBy: "createdAt",
    ascDesc: -1,
    limit: 100,
    page: 0,
    select: "name city",
    search: "",
  })
  const [data, setData] = useState([])

  const {
    match: { params },
  } = props

  useEffect(() => {
    dispatch(onList(params.id, tableSetting))
  }, [tableSetting])

  useEffect(() => {
    setData(branches)
  }, [branches])

  // useEffect(()=>{
  //   if(isEmpty(data) && !isEmpty(params.id)){
  //     setData(branches.filter(x=>x.companyId == params.id))
  //   }
  // },[])

  const columns = useMemo(
    () => [
      {
        Header: props.t("Branch Name"),
        accessor: "name",
        search: false,
      },
      {
        Header: props.t("Branch City"),
        accessor: "city",
        search: false,
      },
      {
        Header: '',
        accessor: "_id",
        search: false,
        Cell: ({ value }) => (
          <div>
            <Link
              to={`/v1/companies/persons?cid=${params.id}&bid=${value}`}
              className="btn btn-sm btn-warning text-white me-2"
            >
              {props.t("Persons")}
            </Link>
            <Link
              to={`/v1/companies/branch/edit/${value}?cid=${params.id}`}
              className="btn btn-sm btn-warning text-white me-2"
            >
              {props.t("Edit")}
            </Link>
          </div>
        ),
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Branches")}
            backLink={"/v1/companies"}
            breadcrumbItems={breadcrumbItems}
            isAdd={true}
            addTitle={props.t("Create Branch")}
            addHandle={() => {
              props.history.push("/v1/companies/branch/create/" + params.id)
            }}
            className={"mb-0 pb-0"}
          />

          <TableContainerServerSide
            loading={loading}
            columns={columns}
            data={data}
            isGlobalFilter={true}
            isAddOptions={false}
            tableSetting={tableSetting}
            customPageSize={tableSetting.limit}
            className="custom-header-css"
            totalCount={branchesTableOptions?.productTotal || 0}
            queryPageIndex={tableSetting.page}
            queryPageSize={tableSetting.limit}
            tableOptions={branchesTableOptions}
            action={(pageIndex, pageSize, search) => {
              setTableSetting({
                orderBy: "createdAt",
                ascDesc: -1,
                limit: pageSize,
                page: pageIndex,
                select: tableSetting.select,
                search: search,
              })
            }}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

Branches.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
}

export default withTranslation()(Branches)
